<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :textWhite="textWhite" />
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
          <div class="input-group">
            <span class="input-group-text text-body"
              ><i class="fas fa-search" aria-hidden="true"></i
            ></span>
            <input
              type="text"
              class="form-control"
              :placeholder="
                this.$store.state.isRTL ? 'أكتب هنا...' : $t(&quot;Type here...&quot;)
              "
            />
          </div>
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center">
            <button type="button" class="btn btn-danger" @click="signout"><portal-text message="Sign Out" :help="false" /> </button>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
              href="#"
              @click="toggleSidebar"
              class="p-0 nav-link text-body"
              id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
         
    
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions } from "vuex";
import Swal from 'sweetalert2';
export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  methods: {
    updateNavbarOnScroll() {
      const navbar = document.getElementById('navbarBlur');
      if (!navbar) return;
      const fixed = window.scrollY > 10 && this.$store.state.isNavFixed;
      for (const name of ['blur', 'position-sticky', 'shadow-blur']) navbar.classList.toggle(name, Boolean(fixed));
    },
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    async signout() {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will be signed out!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, sign me out!'
    });

    if (result.isConfirmed) {
      // Perform the sign-out action
      // You can add additional logic here if needed

      // For example, clear user authentication data from local storage
      localStorage.removeItem('token');

      // Now, you might want to redirect the user to the sign-in page
      // You can use this.$router.push or window.location.href
      // Example using Vue Router:
      this.$router.push({ name: 'Sign In' });

      // Alternatively, if you want to use window.location.href:
      // window.location.href = '/your-sign-in-url';
    }
  },
  },
  components: {
    Breadcrumbs,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateNavbarOnScroll, { passive: true });
    this.updateNavbarOnScroll();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.updateNavbarOnScroll);
  },
};
</script>
